import useFetchObjects from "../../api/useFetchObjects";

const useTrendingTitles = () => {
  // Get token from localStorage
  const token = localStorage.getItem("token");

  return useFetchObjects(
    ["trending-titles"],
    "books/trending_titles/",
    token ? token : null,
    { refetchOnWindowFocus: false },
  );
};

export default useTrendingTitles;
